// src/components/store/QuickCartComponents/DescriptionBox.jsx
import React from "react";
import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";

export const DescriptionBox = ({
  type = "delivery",
  className = "",
  content,
  showBackButton = false,
  onBack,
}) => {
  const defaultContent = {
    bottles: {
      number: "1",
      title: "Botellones",
      description: "Agrega los que necesites.",
      className: "mt-8 mb-2",
    },
    delivery: {
      number: "2",
      title: "Información de entrega",
      description: "Ingresa los datos para la entrega de tu pedido.",
      className: "mt-0 mb-8",
    },
    summary: {
      number: "3",
      title: "Resumen del pedido",
      description: "Revisa tu pedido y acepta los términos y condiciones.",
      className: "mt-0 mb-8",
    },
  };

  const descriptionContent = content || defaultContent[type];

  return (
    <div
      className={`flex items-center border-b pb-4 gap-2 w-full  ${descriptionContent.className}`}
    >
      {/* Botón de retroceso */}
      {showBackButton && (
        <div className="flex gap-2 me-2">
          <motion.button
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={onBack}
            className="rounded-full w-8 h-8 border cursor-pointer flex items-center justify-center bg-gray-50 text-gray-800 hover:bg-gray-100 transition-colors flex-shrink-0"
          >
            <ChevronLeft className="w-4  h-4" />
          </motion.button>
          <div class="w-0.5 0self-stretch bg-neutral-100 rounded-xl"></div>
        </div>
      )}

      {/* Contenido del título y descripción */}
      <h2 className="text-gray-800 text-2xl font-bold leading-none jus p-0 m-0 fraunces ">
        {descriptionContent.title}
      </h2>
    </div>
  );
};

export default DescriptionBox;